import { render } from "./DiscountOverview.vue?vue&type=template&id=53cf5a82&scoped=true"
import script from "./DiscountOverview.vue?vue&type=script&lang=js"
export * from "./DiscountOverview.vue?vue&type=script&lang=js"

import "./DiscountOverview.vue?vue&type=style&index=0&id=53cf5a82&scoped=true&lang=css"

import exportComponent from "C:\\Users\\DimmyMarcelissen\\WebstormProjects\\dividenduitkering\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53cf5a82"]])

export default __exports__